if (!customElements.get('delivery-timer')) {
  customElements.define(
    'delivery-timer',
    class DeliveryTimer extends HTMLElement {
      constructor() {
        super();
        this.monFriDeadline = this.querySelector('.week-timer').dataset.deadline;
        this.satDeadline = this.querySelector('.saturday-next-day').dataset.deadline;
        this.initializeTimer();
      }

      initializeTimer() {
        const currentDay = new Date().getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        const currentTime = new Date();
        const monFriTime = this.parseTime(this.monFriDeadline);
        const satTime = this.parseTime(this.satDeadline);

        if (currentDay >= 1 && currentDay <= 5) {
          // Monday to Friday
          this.checkDeadline(monFriTime, currentTime, '.week-timer', '.week-next-day');
        } else if (currentDay === 6) {
          // Saturday
          this.checkDeadline(satTime, currentTime, '.saturday-timer', '.saturday-next-day');
        } else if (currentDay === 0) {
          // Sunday
          this.querySelector('.saturday-next-day').style.display = 'block';
        }
      }

      checkDeadline(deadline, currentTime, timerSelector, nextDaySelector) {
        const deadlineToday = new Date(currentTime);
        deadlineToday.setHours(deadline.hours, deadline.minutes, 0, 0);

        if (currentTime < deadlineToday) {
          // Show countdown timer
          this.querySelector(timerSelector).style.display = 'block';
          this.startCountdown(deadlineToday, timerSelector, nextDaySelector);
        } else {
          // Show next-day message
          this.querySelector(nextDaySelector).style.display = 'block';
        }
      }

      startCountdown(deadline, timerSelector, nextDaySelector) {
        const countdownElem = this.querySelector(timerSelector).querySelector('.countdown-timer');
        const updateCountdown = () => {
          const now = new Date();
          const timeLeft = deadline - now;

          if (timeLeft <= 0) {
            // Hide timer and show next-day message
            this.querySelector(timerSelector).style.display = 'none';
            this.querySelector(nextDaySelector).style.display = 'block';
            clearInterval(timerInterval);
            return;
          }

          const hours = Math.floor(timeLeft / 3600000);
          const minutes = Math.floor((timeLeft % 3600000) / 60000);
          const seconds = Math.floor((timeLeft % 60000) / 1000);

          // Format output conditionally
          let formattedTime = '';
          if (hours > 0) {
            formattedTime = `${hours} часа, ${minutes} минути и ${seconds} секунди`;
          } else {
            formattedTime = `${minutes} минути и ${seconds} секунди`;
          }

          countdownElem.textContent = formattedTime;
        };

        updateCountdown(); // Initial call
        const timerInterval = setInterval(updateCountdown, 1000);
      }

      parseTime(timeString) {
        const [hours, minutes] = timeString.split(':').map(Number);
        return { hours, minutes };
      }
    }
  );
}
